import Breakpoint from '@core/scripts/helper/breakpoint.js';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import Messages from '@core/scripts/components/messages';
import Landmark from '@core/scripts/components/landmark-adapter';
import JSONParser from '@core/scripts/helper/json-parser';

export default function Module(moduleScope, config) {

    const ACTIVE_CLASS = 'is-active';

    const navigationItemNodes = moduleScope.querySelectorAll("[jsh-navigation__item]");
    const firstLevelLabelNodes = moduleScope.querySelectorAll("[jsh-navigation__item-label='level-first']");
    const navigationItemLabelNodes = moduleScope.querySelectorAll("[jsh-navigation__item-label]");

    const toggleHeightNodes = moduleScope.querySelectorAll("[jsh-navigation__item-content]");
    const scrollOffset = config && config.scrollOffset !== undefined ? parseInt(config.scrollOffset) : 0;

    handleFirstLevelClick = handleFirstLevelClick.bind(this);
    scrollTo = scrollTo.bind(this);

    MessageBroker.subscribe(Messages.BREAKPOINT.CHANGED, initialize.bind(this));

    function isEnabled() {
        return Breakpoint.keyIsIn(["small", "medium"]);
    }

    let initialized = false;

    initialize();

    function initialize() {
        if (!initialized && isEnabled()) {
            firstLevelLabelNodes.forEach((node) => {
                node.addEventListener('click', handleFirstLevelClick);
            });

            if (firstLevelLabelNodes.length === 1) {
                const singleItemNode = firstLevelLabelNodes[0].closest("[jsh-navigation__item]");
                const contentNode = singleItemNode.querySelector("[jsh-navigation__item-content]");

                if (contentNode?.children.length > 0) {
                    setContentHeight(singleItemNode);
                }
            }

            initialized = true;
        } else if (initialized && !isEnabled()) {
            firstLevelLabelNodes.forEach((node) => {
                node.removeEventListener('click', handleFirstLevelClick);
            });
            initialized = false;
        }
    }

    function handleFirstLevelClick(e) {
        e.preventDefault();
        const currentItemNode = e.currentTarget.closest("[jsh-navigation__item]");
        const contentNode = currentItemNode.querySelector("[jsh-navigation__item-content]");

        if (contentNode?.children.length > 0) {
            toggleItem(currentItemNode);
        }
    }

    function setContentHeight(currentItemNode) {
        const itemContent = currentItemNode.querySelector('[jsh-navigation__item-content]');
        let contentHeight = 0;

        for (const itemContentChild of [...itemContent.children]) {
            contentHeight += itemContentChild.offsetHeight;
        }

        itemContent.style.maxHeight = `${contentHeight}px`;
    }

    function toggleItem(currentItemNode) {
        const currentLabelNode = currentItemNode.querySelector("[jsh-navigation__item-label]");
        const isCurrentItemOpen = currentItemNode.classList.contains(ACTIVE_CLASS);

        sendLandmark(currentItemNode, isCurrentItemOpen);
        moduleScope.classList.remove('is-loading');

        closeAllNavigationItems();

        if (!isCurrentItemOpen) {
            currentItemNode.classList.add(ACTIVE_CLASS);
            currentLabelNode.classList.add(ACTIVE_CLASS);

            setContentHeight(currentItemNode);
            scrollTo(currentLabelNode);
        }
    }

    function scrollTo(currentLabelNode) {
        const scrollValue = currentLabelNode.offsetTop - scrollOffset;
        window.scroll({
            top: scrollValue,
            behavior: 'smooth'
        });
    }

    function closeAllNavigationItems() {
        toggleHeightNodes.forEach((node) => {
            node.style.maxHeight = '';
        });
        navigationItemNodes.forEach((node) => {
            node.classList.remove(ACTIVE_CLASS);
        });
        navigationItemLabelNodes.forEach((node) => {
            node.classList.remove(ACTIVE_CLASS);
        });
    }

    function sendLandmark(currentItemNode, isCurrentItemOpen) {
        const landmarks = JSONParser.tryParseJSON(currentItemNode.getAttribute("jsh-navigation__item-landmark"));
        if (landmarks) {
            if (isCurrentItemOpen) {
                Landmark.sendLandmark(landmarks.close);
            } else {
                Landmark.sendLandmark(landmarks.open);
            }
        }
    }
}
